import { Permissions } from './constants/permissions';
import RolePermissions from './constants/rolePermissions';
import type { AuthUserType } from './types';

type PermissionSource = string | ReadonlyArray<string> | null | undefined;

const authUserTypeByValue: Record<string, AuthUserType> = {
    SaleConsultant: 'SaleConsultant',
    saleConsultant: 'SaleConsultant',
    Dealer: 'Dealer',
    dealer: 'Dealer',
    Admin: 'Admin',
    admin: 'Admin',
    Root: 'Root',
    root: 'Root',
    SalesManager: 'SalesManager',
    salesManager: 'SalesManager',
    Purchaser: 'Purchaser',
    purchaser: 'Purchaser',
};
const toAuthUserType = (userType: string | null | undefined): AuthUserType | null =>
    userType ? authUserTypeByValue[userType] ?? null : null;

export const getPermissionsForRole = (role: string | null | undefined): Permissions[] => {
    const authUserType = toAuthUserType(role);

    return authUserType ? RolePermissions[authUserType] ?? [] : [];
};

const toGrantedPermissions = (source: PermissionSource): ReadonlyArray<string> => {
    if (Array.isArray(source)) {
        return source;
    }

    if (typeof source !== 'string') {
        return [];
    }

    return getPermissionsForRole(source);
};

export const hasPermission = (source: PermissionSource, permission: string): boolean =>
    toGrantedPermissions(source).includes(permission);

export const hasAllPermissions = (source: PermissionSource, permissions: ReadonlyArray<string>): boolean =>
    permissions.every(permission => hasPermission(source, permission));

export const hasOneOfPermissions = (source: PermissionSource, permissions: ReadonlyArray<string>): boolean =>
    permissions.some(permission => hasPermission(source, permission));
